import { ReportData } from '../types/reportTypes';

// May 2026 Sales Data - Standard Report (46 jobs)
// Source: sample csv/GP MARGINS REPORT MAY 2026.xlsx (single file with both sales rows and ad spend breakdown)
// Totals reconcile with xlsx Totals row (sub-cent rounding drift on Mgr +$0.06, OH +$0.02
// from rounding xlsx sub-cent precision values to 2 decimals; well within prior-month tolerances):
//   CT $458,636.82 | GP $227,621.31 | Comm $26,823.83 | Mgr ~$1,770.30 | OH ~$71,088.71
// Trade name normalization (per CLAUDE.md rules + Ken direction):
//   - "ROI " prefix stripped
//   - Multi-trade entries use first trade: E-1052 -> Siding, E-1065 -> Siding,
//     E-1087 ("Windows & Doors, Seamless Gutters, ROI Roofing, Siding - Vinyl") -> Windows & Doors
//   - E-1039 "Roofing - Shingles" normalized to "Roofing" (per user)
//   - "Attic Insulation" preserved (E-1071, E-1078, E-1084, E-1086)
// 11 placeholder-margin rows (40% GP, Prospect/Assigned Lead milestones) included with
// pre-calculated commissions per Rule 4 (NO-PPP-equivalent for the xlsx format).
const jobData = [
  {
    jobInfo: "E-1092: Rebecca Taylor",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 2372.00,
    grossMarginPct: 0.6235,
    grossProfit: 1479.05,
    commissionPercentage: 10.0,
    salesCommission: 237.20,
    salesManagerFee: 23.72,
    companyOH: 367.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1071: Phil & Denise Tarbell",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 4947.00,
    grossMarginPct: 0.7029,
    grossProfit: 3477.00,
    commissionPercentage: 10.0,
    salesCommission: 494.70,
    salesManagerFee: 49.47,
    companyOH: 766.79,
    netProfit: 0
  },
  {
    jobInfo: "E-1049: Asad & Dilshod & Komola Zsarov NURMATOV",
    leadSource: "Referral - Word of mouth",
    trade: "Roofing",
    contractTotal: 7880.48,
    grossMarginPct: 0.4137,
    grossProfit: 3260.23,
    commissionPercentage: 4.0,
    salesCommission: 315.22,
    salesManagerFee: 12.61,
    companyOH: 1221.47,
    netProfit: 0
  },
  {
    jobInfo: "E-1060: Richard Hines",
    leadSource: "Self Generated Lead (By Rep)",
    trade: "Roofing",
    contractTotal: 23910.00,
    grossMarginPct: 0.4949,
    grossProfit: 11833.84,
    commissionPercentage: 4.0,
    salesCommission: 956.40,
    salesManagerFee: 38.26,
    companyOH: 3706.05,
    netProfit: 0
  },
  {
    jobInfo: "E-1043: Sophy Ssenkubuge",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 24820.48,
    grossMarginPct: 0.6505,
    grossProfit: 16144.75,
    commissionPercentage: 10.0,
    salesCommission: 2482.05,
    salesManagerFee: 248.20,
    companyOH: 3847.17,
    netProfit: 0
  },
  {
    jobInfo: "E-1038: Shannon & MICHAEL Alexander",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 18752.00,
    grossMarginPct: 0.4394,
    grossProfit: 8239.76,
    commissionPercentage: 4.0,
    salesCommission: 750.08,
    salesManagerFee: 30.00,
    companyOH: 2906.56,
    netProfit: 0
  },
  {
    jobInfo: "E-1041: Karen Price",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 11572.00,
    grossMarginPct: 0.4097,
    grossProfit: 4740.58,
    commissionPercentage: 4.0,
    salesCommission: 462.88,
    salesManagerFee: 18.52,
    companyOH: 1793.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1034: Brie & Blanche Davis",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 5852.00,
    grossMarginPct: 0.5583,
    grossProfit: 3267.00,
    commissionPercentage: 7.0,
    salesCommission: 409.64,
    salesManagerFee: 28.67,
    companyOH: 907.06,
    netProfit: 0
  },
  {
    jobInfo: "E-1040: Thomece & Roberto Lord",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 3677.68,
    grossMarginPct: 0.6163,
    grossProfit: 2266.43,
    commissionPercentage: 10.0,
    salesCommission: 367.77,
    salesManagerFee: 36.78,
    companyOH: 570.04,
    netProfit: 0
  },
  {
    jobInfo: "E-1036: Anthony Francis",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 2724.00,
    grossMarginPct: 0.5070,
    grossProfit: 1381.00,
    commissionPercentage: 7.0,
    salesCommission: 190.68,
    salesManagerFee: 13.35,
    companyOH: 422.22,
    netProfit: 0
  },
  {
    jobInfo: "E-1055: Rebecca & Matt Walker",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 2024.80,
    grossMarginPct: 0.5417,
    grossProfit: 1096.80,
    commissionPercentage: 7.0,
    salesCommission: 141.74,
    salesManagerFee: 9.92,
    companyOH: 313.84,
    netProfit: 0
  },
  {
    jobInfo: "E-1027: Patricia & Leroy Toliver",
    leadSource: "Angi",
    trade: "Roofing",
    contractTotal: 8658.00,
    grossMarginPct: 0.4240,
    grossProfit: 3670.77,
    commissionPercentage: 4.0,
    salesCommission: 346.32,
    salesManagerFee: 13.85,
    companyOH: 1341.99,
    netProfit: 0
  },
  {
    jobInfo: "E-1089: Brandon & Herminia Steele",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 5976.00,
    grossMarginPct: 0.6330,
    grossProfit: 3783.01,
    commissionPercentage: 10.0,
    salesCommission: 597.60,
    salesManagerFee: 59.76,
    companyOH: 926.28,
    netProfit: 0
  },
  {
    jobInfo: "E-1080: Michelle & REBECCA Carrigan",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 10499.00,
    grossMarginPct: 0.4365,
    grossProfit: 4582.80,
    commissionPercentage: 4.0,
    salesCommission: 419.96,
    salesManagerFee: 16.80,
    companyOH: 1627.35,
    netProfit: 0
  },
  {
    jobInfo: "E-1085: Christopher Gardener & Frankie Scroggins",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 3023.52,
    grossMarginPct: 0.4901,
    grossProfit: 1481.84,
    commissionPercentage: 4.0,
    salesCommission: 120.94,
    salesManagerFee: 4.84,
    companyOH: 468.65,
    netProfit: 0
  },
  {
    jobInfo: "E-1069: Jeri & George Hall",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 12266.00,
    grossMarginPct: 0.5485,
    grossProfit: 6728.15,
    commissionPercentage: 7.0,
    salesCommission: 858.62,
    salesManagerFee: 60.10,
    companyOH: 1901.23,
    netProfit: 0
  },
  {
    jobInfo: "E-1075: Theodore & Sally Goodman",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 18622.00,
    grossMarginPct: 0.5349,
    grossProfit: 9961.34,
    commissionPercentage: 7.0,
    salesCommission: 1303.54,
    salesManagerFee: 91.25,
    companyOH: 2886.41,
    netProfit: 0
  },
  {
    jobInfo: "E-1061: John Protzman",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 10392.00,
    grossMarginPct: 0.4018,
    grossProfit: 4175.81,
    commissionPercentage: 4.0,
    salesCommission: 415.68,
    salesManagerFee: 16.63,
    companyOH: 1610.76,
    netProfit: 0
  },
  {
    jobInfo: "E-1059: Avonnie Kemp",
    leadSource: "Angi",
    trade: "Windows & Doors",
    contractTotal: 3272.00,
    grossMarginPct: 0.4144,
    grossProfit: 1355.95,
    commissionPercentage: 4.0,
    salesCommission: 130.88,
    salesManagerFee: 5.24,
    companyOH: 507.16,
    netProfit: 0
  },
  {
    jobInfo: "E-1052: Lindsay & Travis Montague",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 40468.00,
    grossMarginPct: 0.5620,
    grossProfit: 22744.26,
    commissionPercentage: 7.0,
    salesCommission: 2832.76,
    salesManagerFee: 198.29,
    companyOH: 6272.54,
    netProfit: 0
  },
  {
    jobInfo: "E-1057: Darrell & VORIS Rivera",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 5997.00,
    grossMarginPct: 0.5424,
    grossProfit: 3252.70,
    commissionPercentage: 7.0,
    salesCommission: 419.79,
    salesManagerFee: 29.39,
    companyOH: 929.54,
    netProfit: 0
  },
  {
    jobInfo: "E-1020: Shante & William Henderson Jackson",
    leadSource: "Referral - From past customer",
    trade: "Windows & Doors",
    contractTotal: 10255.36,
    grossMarginPct: 0.4232,
    grossProfit: 4339.65,
    commissionPercentage: 4.0,
    salesCommission: 410.21,
    salesManagerFee: 16.41,
    companyOH: 1589.58,
    netProfit: 0
  },
  {
    jobInfo: "E-1084: Ehren Koontz",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 2372.00,
    grossMarginPct: 0.7007,
    grossProfit: 1662.00,
    commissionPercentage: 10.0,
    salesCommission: 237.20,
    salesManagerFee: 23.72,
    companyOH: 367.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1086: Theodore & LE HANH Roorda",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 1742.00,
    grossMarginPct: 0.4506,
    grossProfit: 785.00,
    commissionPercentage: 4.0,
    salesCommission: 69.68,
    salesManagerFee: 2.79,
    companyOH: 270.01,
    netProfit: 0
  },
  {
    jobInfo: "E-1099: Srikanth Katragadda & Kathleen Cochrane",
    leadSource: "Referral - Word of mouth",
    trade: "Roofing",
    contractTotal: 20874.00,
    grossMarginPct: 0.5727,
    grossProfit: 11955.23,
    commissionPercentage: 7.0,
    salesCommission: 1461.18,
    salesManagerFee: 102.28,
    companyOH: 3235.47,
    netProfit: 0
  },
  {
    jobInfo: "E-1078: Khail & Tylor Bryant & Scales",
    leadSource: "Thumbtack",
    trade: "Attic Insulation",
    contractTotal: 2950.00,
    grossMarginPct: 0.6086,
    grossProfit: 1795.25,
    commissionPercentage: 10.0,
    salesCommission: 295.00,
    salesManagerFee: 29.50,
    companyOH: 457.25,
    netProfit: 0
  },
  {
    jobInfo: "E-1088: Ron & Renata Creech",
    leadSource: "eLocal",
    trade: "Roofing",
    contractTotal: 20972.00,
    grossMarginPct: 0.4020,
    grossProfit: 8431.00,
    commissionPercentage: 4.0,
    salesCommission: 838.88,
    salesManagerFee: 33.56,
    companyOH: 3250.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1067: Corey & CELESTE Rolle",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 2298.00,
    grossMarginPct: 0.5371,
    grossProfit: 1234.17,
    commissionPercentage: 7.0,
    salesCommission: 160.86,
    salesManagerFee: 11.26,
    companyOH: 356.19,
    netProfit: 0
  },
  {
    jobInfo: "E-1053: Belinda & Alexandra Anderson",
    leadSource: "Angi",
    trade: "Roofing",
    contractTotal: 10586.00,
    grossMarginPct: 0.6202,
    grossProfit: 6565.70,
    commissionPercentage: 10.0,
    salesCommission: 1058.60,
    salesManagerFee: 105.86,
    companyOH: 1640.83,
    netProfit: 0
  },
  {
    jobInfo: "E-1056: Charlie Steve Guardado",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 6412.00,
    grossMarginPct: 0.4640,
    grossProfit: 2974.86,
    commissionPercentage: 4.0,
    salesCommission: 256.48,
    salesManagerFee: 10.26,
    companyOH: 993.86,
    netProfit: 0
  },
  {
    jobInfo: "E-1039: Patricia Bradley",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 16446.05,
    grossMarginPct: 0.5500,
    grossProfit: 9044.71,
    commissionPercentage: 7.0,
    salesCommission: 1151.22,
    salesManagerFee: 80.59,
    companyOH: 2549.14,
    netProfit: 0
  },
  {
    jobInfo: "Breona Jenkins",
    leadSource: "Thumbtack",
    trade: "Gutters",
    contractTotal: 1772.00,
    grossMarginPct: 0.4000,
    grossProfit: 708.80,
    commissionPercentage: 4.0,
    salesCommission: 70.88,
    salesManagerFee: 2.84,
    companyOH: 274.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1079: Shirley Glover",
    leadSource: "Angi",
    trade: "Siding",
    contractTotal: 16498.00,
    grossMarginPct: 0.4000,
    grossProfit: 6599.20,
    commissionPercentage: 4.0,
    salesCommission: 659.92,
    salesManagerFee: 26.40,
    companyOH: 2557.19,
    netProfit: 0
  },
  {
    jobInfo: "E-1076: Abel & Etenesh Kereta",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 3772.00,
    grossMarginPct: 0.4000,
    grossProfit: 1508.80,
    commissionPercentage: 4.0,
    salesCommission: 150.88,
    salesManagerFee: 6.04,
    companyOH: 584.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1083: Barron Brooks",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 13372.00,
    grossMarginPct: 0.4356,
    grossProfit: 5824.88,
    commissionPercentage: 4.0,
    salesCommission: 534.88,
    salesManagerFee: 21.40,
    companyOH: 2072.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1062: Daron & Amara Vaughn",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 4850.00,
    grossMarginPct: 0.4097,
    grossProfit: 1986.93,
    commissionPercentage: 4.0,
    salesCommission: 194.00,
    salesManagerFee: 7.76,
    companyOH: 751.75,
    netProfit: 0
  },
  {
    jobInfo: "E-1065: Ramona Femenias",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 35522.00,
    grossMarginPct: 0.5263,
    grossProfit: 18696.32,
    commissionPercentage: 7.0,
    salesCommission: 2486.54,
    salesManagerFee: 174.06,
    companyOH: 5505.91,
    netProfit: 0
  },
  {
    jobInfo: "E-1097: Stephen Neathery",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 6173.00,
    grossMarginPct: 0.4000,
    grossProfit: 2469.20,
    commissionPercentage: 4.0,
    salesCommission: 246.92,
    salesManagerFee: 9.88,
    companyOH: 956.82,
    netProfit: 0
  },
  {
    jobInfo: "E-1091: Charles Wilson",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 7007.00,
    grossMarginPct: 0.4000,
    grossProfit: 2802.80,
    commissionPercentage: 4.0,
    salesCommission: 280.28,
    salesManagerFee: 11.21,
    companyOH: 1086.09,
    netProfit: 0
  },
  {
    jobInfo: "E-1096: Ted Carten",
    leadSource: "Thumbtack",
    trade: "Siding",
    contractTotal: 6372.00,
    grossMarginPct: 0.4000,
    grossProfit: 2548.80,
    commissionPercentage: 4.0,
    salesCommission: 254.88,
    salesManagerFee: 10.20,
    companyOH: 987.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1063: Yvette Lapompe",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 4297.70,
    grossMarginPct: 0.4000,
    grossProfit: 1719.08,
    commissionPercentage: 4.0,
    salesCommission: 171.91,
    salesManagerFee: 6.88,
    companyOH: 666.14,
    netProfit: 0
  },
  {
    jobInfo: "Milton Lee & Nichol Chan-lee",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 5650.00,
    grossMarginPct: 0.4000,
    grossProfit: 2260.00,
    commissionPercentage: 4.0,
    salesCommission: 226.00,
    salesManagerFee: 9.04,
    companyOH: 875.75,
    netProfit: 0
  },
  {
    jobInfo: "Julie & Tyler Doyle",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 4250.00,
    grossMarginPct: 0.4000,
    grossProfit: 1700.00,
    commissionPercentage: 4.0,
    salesCommission: 170.00,
    salesManagerFee: 6.80,
    companyOH: 658.75,
    netProfit: 0
  },
  {
    jobInfo: "E-1074: Brent & Olga Levy",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 2649.00,
    grossMarginPct: 0.5076,
    grossProfit: 1344.58,
    commissionPercentage: 7.0,
    salesCommission: 185.43,
    salesManagerFee: 12.98,
    companyOH: 410.60,
    netProfit: 0
  },
  {
    jobInfo: "E-1087: Kevin & Margaret Mercer",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 22372.00,
    grossMarginPct: 0.4007,
    grossProfit: 8965.53,
    commissionPercentage: 4.0,
    salesCommission: 894.88,
    salesManagerFee: 35.80,
    companyOH: 3467.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1070: Darlene Dix",
    leadSource: "Previous Customer",
    trade: "Gutters",
    contractTotal: 1466.75,
    grossMarginPct: 0.5289,
    grossProfit: 775.75,
    commissionPercentage: 7.0,
    salesCommission: 102.67,
    salesManagerFee: 7.19,
    companyOH: 227.35,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit (Standard Report formula)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);
const totalManagerFees = jobData.reduce((sum, job) => sum + job.salesManagerFee, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);

// Ad spend data from May 2026 (AD SPEND DATA block in same xlsx, rows 60-95).
// Filtered: skipped OUTBOUND/INBOUND/TOTAL OVERALL subtotal rows; kept all individual sources
// (including zero-spend rows for completeness, matching prior months' patterns).
// Sum matches xlsx Net Profit block: $87,699.20.
const adSpendData = [
  { source: "Networx", spend: 421.88 },
  { source: "Thumbtack", spend: 4500.00 },
  { source: "Yelp", spend: 11794.32 },
  { source: "Porch", spend: 0.00 },
  { source: "Web to Lead Form", spend: 240.00 },
  { source: "Angi", spend: 5000.00 },
  { source: "Homebuddy", spend: 0.00 },
  { source: "RoofHero", spend: 0.00 },
  { source: "Buyerlink", spend: 0.00 },
  { source: "Lead2performance", spend: 0.00 },
  { source: "Contractors Appointments", spend: 0.00 },
  { source: "Google Organic Search", spend: 5500.00 },
  { source: "Google Paid Search", spend: 56500.00 },
  { source: "Facebook / Meta Ads", spend: 0.00 },
  { source: "Missed Call", spend: 0.00 },
  { source: "Previous Customer", spend: 0.00 },
  { source: "Other", spend: 0.00 },
  { source: "Truck", spend: 0.00 },
  { source: "Referral - From past customer", spend: 0.00 },
  { source: "DataDump GoHighLevel", spend: 0.00 },
  { source: "Referral - Word of mouth", spend: 0.00 },
  { source: "Email Campaign", spend: 0.00 },
  { source: "SpringConnect - Call Center", spend: 0.00 },
  { source: "Self Generated Lead (By Rep)", spend: 0.00 },
  { source: "BBB", spend: 300.00 },
  { source: "Events Division", spend: 0.00 },
  { source: "Yard Sign", spend: 0.00 },
  { source: "ROI Sales Portal", spend: 0.00 },
  { source: "Modernize", spend: 0.00 },
  { source: "33 Mile Radius / Everconnect", spend: 943.00 },
  { source: "eLocal", spend: 2500.00 }
];

const totalAdSpend = adSpendData.reduce((sum, item) => sum + item.spend, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

export const may2026Data: ReportData = {
  kpis: {
    adSpend: totalAdSpend,
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: totalManagerFees,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit - totalAdSpend,
    netProfitPercent: (totalNetProfit - totalAdSpend) / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: adSpendData,
  salesBySource: salesBySource,
  salesByTrade: salesByTrade,
  jobData: jobData,

  period: {
    month: 5,
    year: 2026
  }
};
